import Marquee from "react-fast-marquee";

const roles = [
  "Architects",
  "Town Planners",
  "Landscape Architects",
  "Urban Designers",
  "Surveyors",
  "Environmental Consultants",
  "GIS Specialists",
];

export const RoleMarquee = () => (
  <section data-testid="role-marquee" className="border-y border-border py-8 bg-[#F4F4F1] overflow-hidden">
    <Marquee speed={40} gradient={false}>
      {roles.concat(roles).map((r, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display font-black text-5xl md:text-7xl tracking-tighter hollow-text px-8">
            {r}
          </span>
          <span className="text-primary text-4xl px-2">✦</span>
        </span>
      ))}
    </Marquee>
  </section>
);
